import { Box, Flex, Label, Text, type GridColDef } from '@shared/components';
import { dayjs } from '@shared/utils';
import { UserTypeAvatar } from '@user-management/components';

import { USER_COLOR_STATUS, USER_STATUS_TEXT, UserStatus } from '../../constants';

export interface RoleUserAdditionListItem {
  id: string;
  firstName: string;
  lastName: string;
  status: UserStatus;
  email: string;
  profilePic: string;
  invitationExpireAt?: Date | string | null;
}

export const columns: GridColDef<RoleUserAdditionListItem>[] = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    renderCell: (params) => {
      const { firstName, lastName, email, profilePic } = params.row;
      return (
        <Flex sx={{ gap: (theme) => theme.spacing(3) }}>
          <UserTypeAvatar fullName={`${firstName} ${lastName}`} email={email} src={profilePic} />
          <Box>
            <Text variant='body1Semibold'>
              {firstName} {lastName}
            </Text>
            <Text variant='body2' sx={{ color: (theme) => theme.palette.text.secondary }}>
              {email}
            </Text>
          </Box>
        </Flex>
      );
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    renderCell: (params) => {
      if (!params.row.status) return null;

      let status = params.row.status;
      if (
        status === UserStatus.INVITATION_PENDING &&
        dayjs(params.row.invitationExpireAt).isBefore(dayjs())
      ) {
        status = UserStatus.INVITATION_EXPIRED;
      }
      return (
        <Label
          sx={{ px: (theme) => theme.spacing(3) }}
          color={USER_COLOR_STATUS[status]}
          variant='outlined'
        >
          {USER_STATUS_TEXT[status]}
        </Label>
      );
    },
  },
];
